// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.login-container {
  background: white;
  border-radius: 16px;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo {
  margin-bottom: 24px;
}

.logo-image {
  height: 60px;
  width: auto;
  object-fit: contain;
}

.login-header h2 {
  margin: 0 0 8px 0;
  color: var(--main-text-color);
  font-size: 1.8rem;
  font-weight: 700;
}

.login-header p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.login-form {
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: var(--main-text-color);
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 3px rgba(127, 204, 159, 0.1);
}

.form-group input.error {
  border-color: #F44336;
}

.form-group input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f9f9f9;
}

.password-input-container {
  position: relative;
}

.password-input-container input {
  padding-right: 50px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;
  font-size: 16px;
  transition: color 0.3s;
}

.password-toggle:hover:not(:disabled) {
  color: var(--main-text-color-highligth);
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.error-message {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 20px;
  border: 1px solid #ffcdd2;
}

.login-button {
  width: 100%;
  padding: 16px;
  background: var(--ar-buttons-bg);
  color: var(--main-text-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover:not(:disabled) {
  background: var(--secondary-color);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #e1e5e9;
}

.login-footer p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.contact-admin-link {
  color: var(--main-text-color-highligth);
  background: none;
  border: none;
  font-size: inherit;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.contact-admin-link:hover {
  color: var(--secondary-color);
}

/* Mobile Responsive */
@media (max-width: 480px) {
  .login-overlay {
    padding: 15px;
  }
  
  .login-container {
    padding: 30px 20px;
  }
  
  .login-header h2 {
    font-size: 1.5rem;
  }
  
  .logo-image {
    height: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/Login.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".login-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.login-container {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 40px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.login-header {\r\n  text-align: center;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.login-logo {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.logo-image {\r\n  height: 60px;\r\n  width: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.login-header h2 {\r\n  margin: 0 0 8px 0;\r\n  color: var(--main-text-color);\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.login-header p {\r\n  margin: 0;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.login-form {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: 600;\r\n  color: var(--main-text-color);\r\n  font-size: 14px;\r\n}\r\n\r\n.form-group input {\r\n  width: 100%;\r\n  padding: 14px 16px;\r\n  border: 2px solid #e1e5e9;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  transition: border-color 0.3s, box-shadow 0.3s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-color);\r\n  box-shadow: 0 0 0 3px rgba(127, 204, 159, 0.1);\r\n}\r\n\r\n.form-group input.error {\r\n  border-color: #F44336;\r\n}\r\n\r\n.form-group input:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.password-input-container {\r\n  position: relative;\r\n}\r\n\r\n.password-input-container input {\r\n  padding-right: 50px;\r\n}\r\n\r\n.password-toggle {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  color: #666;\r\n  font-size: 16px;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.password-toggle:hover:not(:disabled) {\r\n  color: var(--main-text-color-highligth);\r\n}\r\n\r\n.password-toggle:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.error-message {\r\n  background: #ffebee;\r\n  color: #c62828;\r\n  padding: 12px 16px;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #ffcdd2;\r\n}\r\n\r\n.login-button {\r\n  width: 100%;\r\n  padding: 16px;\r\n  background: var(--ar-buttons-bg);\r\n  color: var(--main-text-color);\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.login-button:hover:not(:disabled) {\r\n  background: var(--secondary-color);\r\n}\r\n\r\n.login-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.login-footer {\r\n  text-align: center;\r\n  padding-top: 24px;\r\n  border-top: 1px solid #e1e5e9;\r\n}\r\n\r\n.login-footer p {\r\n  margin: 0;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.contact-admin-link {\r\n  color: var(--main-text-color-highligth);\r\n  background: none;\r\n  border: none;\r\n  font-size: inherit;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  padding: 0;\r\n}\r\n\r\n.contact-admin-link:hover {\r\n  color: var(--secondary-color);\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 480px) {\r\n  .login-overlay {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .login-container {\r\n    padding: 30px 20px;\r\n  }\r\n  \r\n  .login-header h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .logo-image {\r\n    height: 50px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
